// LEGACY: being replaced by components/designSystem/button. Do not restyle in place; new screens should use the design system.
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Spinner from '@client/components/spinner/Spinner';
import styles from './buttonWithLoader.scss';

function ButtonWithLoader({
  className,
  classNameWhenLoading,
  disabled,
  label,
  classNameLabel,
  icon,
  onClick,
  loading,
  spinnerColor = '#1d1d1d',
  ...rest
}) {
  return (
    <button
      className={classNames(
        styles.buttonWithLoader,
        loading && classNameWhenLoading,
        className
      )}
      type="button"
      disabled={disabled || loading}
      onClick={onClick}
      {...rest}
    >
      {loading && <Spinner className={styles.spinner} color={spinnerColor} />}
      <span
        className={classNames(
          styles.label,
          classNameLabel && classNameLabel,
          loading && styles.hideOnLoading
        )}
      >
        {icon && icon}
        {label && label}
      </span>
    </button>
  );
}

ButtonWithLoader.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  classNameLabel: PropTypes.string,
  classNameWhenLoading: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.node,
  spinnerColor: PropTypes.string,
};

export default React.memo(ButtonWithLoader);
